// extracted by mini-css-extract-plugin
module.exports = {"achievements-item":"AchievementItem_achievements-item__3XUHO"};